import { selectChangeMessageForCheckbox } from '@UI/aside/asideCheckbox/AsideCheckboxSelectors';
import { selectChangeMessageForNewsletterSenders } from '@UI/aside/asideNewsletterSender/asideNewsletterSenderSelectors';
import {
  loadNewsletterSettings,
  loadWebConfigurations,
} from '@newStore/documentApi/documentApiState';
import { selectChangeMessageForDateToSend } from '@newStore/documentUI/changeMessageSelectors/selectChangeMessageForDate';
import { selectChangeMessageForSimpleDropdown } from '@newStore/documentUI/changeMessageSelectors/selectChangeMessageForSimpleDropdown';
import { selectTitleNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { getAllOfResource } from '@newStore/externalData/externalDataState';
import { pathMap } from '@newStore/externalData/externalDataTypes';
import { referenceFrames } from '@newStore/referenceFrames/referenceFrames';
import { loadReferenceFrame } from '@newStore/referenceFrames/referenceFramesState';
import { NodeType, RequiredType, type RootNodeConfig } from '@nodeTypeConfig/configTypes';
import { authorsComponent } from '@nodeTypeConfig/helpers/editComponents/authorsComponent';
import { proNewsletterAudienceTab } from '@nodeTypeConfig/helpers/editComponents/proNewsletterAudienceTab';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';
import { loadNamedSetsAction } from '@store/actions/documentActions';
import * as ACTION_TYPES from '@store/constants/actionTypes';
import constants from '../../../../reduxLoop/constants/constants';
import { settings } from '../../../settings';

export const PRONEWSLETTER: RootNodeConfig = {
  nodeSelector: selectTitleNode,
  validationRules: [],
  information: {
    definiteArticle: true,
    single: 'PRO.-nieuwsbrief',
    plural: 'PRO.-nieuwsbrieven',
    icon: require('../../../../../img/icons/document.svg'),
    category: 'PRO',
  },
  onLoadActions: [
    loadWebConfigurations(), // the teasers need this info.
    loadNewsletterSettings(),
    getAllOfResource({ resource: pathMap.newsletterSenders, refresh: false }),
    getAllOfResource({ resource: pathMap.namedSets, refresh: false }),
    loadReferenceFrame({ referenceFrame: referenceFrames.pro }),
    /**
     * the ACTION_TYPES.PATCH_THEMES action still needs the doelgroepen namedset to be present
     * in the old reducer.
     * Once the PATCH_xxx actions are removed, this action can be removed as well.
     */
    loadNamedSetsAction('doelgroepen'),
  ],
  createDefaults: { newsletterSender: { href: constants.dienstCommunicatieSender } },
  createModal: {
    authors: { addUser: true },
    newsLetterTemplate: { required: true },
    dateToSend: { required: true },
  },
  preloadActions: [{ type: ACTION_TYPES.GET_NEWSLETTER_SETTINGS }],
  websiteHref: null,
  buildingBlocks: [
    { type: NodeType.SECTION },
    { type: NodeType.PARAGRAPH },
    { type: NodeType.IMAGE },
    { type: NodeType.PRO_NEWSLETTER_CALENDAR },
    { type: NodeType.WORD_IMPORT },
  ],
  tocTypes: [NodeType.SECTION, NodeType.PRO_NEWSLETTER_SECTION],
  referenceGroupTypes: [constants.referenceGroupTypes.TRAINING],
  edit: [
    {
      component: 'newsletterType',
      property: 'newsletterType.href',
      reactComponent: 'AsideSimpleDropDown',
      label: 'Nieuwsbrief Type',
      required: RequiredType.ERROR,
      readonly: true,
      options: {
        clearable: false,
        options: [
          {
            key: '/newsletter/types/f64b33d8-dbd9-49b8-845b-4f3f2a6c2b78',
            label: 'Algemene nieuwsbrief',
          },
          {
            key: '/newsletter/types/974c6b12-2b90-4d8d-a98f-67b2daab0d8b',
            label: 'Leerplannennieuwsbrief',
          },
        ],
      },
      asideChangeMessageSelector: selectChangeMessageForSimpleDropdown,
    },
    titleComponent,
    {
      component: 'dateToSend',
      label: 'Verwachte verzenddatum',
      reactComponent: 'AsideDateToSendPicker',
      options: {
        openTo: 'day',
      },
      asideChangeMessageSelector: selectChangeMessageForDateToSend,
    },
    {
      component: 'newsletterSender',
      reactComponent: 'AsideNewsletterSender',
      property: 'newsletterSender.href',
      asideChangeMessageSelector: selectChangeMessageForNewsletterSenders,
      label: 'Afzender',
      required: RequiredType.ERROR,
    },
    {
      component: 'tableOfContents',
      property: 'tableOfContents',
      label: 'Inhoudstafel',
      reactComponent: 'AsideCheckbox',
      asideChangeMessageSelector: selectChangeMessageForCheckbox,
    },
    authorsComponent,
  ],
  audienceTab: proNewsletterAudienceTab,
  customEditorOptions: {
    showMarkerButton: false,
    hideTermButton: true,
  },
  isCreatable: true,
  isSearchable: true,
  isImportable: false,
  allowSuggestions: false,
  websiteEdition: [{ domain: settings.domains.www }, { domain: settings.domains.pro }],
};
